export const FETCH_AUTO_ACCEPT_REQUEST = 'FETCH_AUTO_ACCEPT_REQUEST';
export const FETCH_AUTO_ACCEPT_SUCCESS = 'FETCH_AUTO_ACCEPT_SUCCESS';
export const FETCH_AUTO_ACCEPT_FAILURE = 'FETCH_AUTO_ACCEPT_FAILURE';

export const UPDATE_AUTO_ACCEPT_REQUEST = 'UPDATE_AUTO_ACCEPT_REQUEST';
export const UPDATE_AUTO_ACCEPT_SUCCESS = 'UPDATE_AUTO_ACCEPT_SUCCESS';
export const UPDATE_AUTO_ACCEPT_FAILURE = 'UPDATE_AUTO_ACCEPT_FAILURE';

export const CLEAR_AUTO_ACCEPT_ERRORS_REQUEST = 'CLEAR_AUTO_ACCEPT_ERRORS_REQUEST';
export const CLEAR_AUTO_ACCEPT_ERRORS_SUCCESS = 'CLEAR_AUTO_ACCEPT_ERRORS_SUCCESS';
export const CLEAR_AUTO_ACCEPT_ERRORS_FAILURE = 'CLEAR_AUTO_ACCEPT_ERRORS_FAILURE';

export const FETCH_AUTO_ACCEPT_STATUS_REQUEST = 'FETCH_AUTO_ACCEPT_STATUS_REQUEST';
export const FETCH_AUTO_ACCEPT_STATUS_SUCCESS = 'FETCH_AUTO_ACCEPT_STATUS_SUCCESS';
export const FETCH_AUTO_ACCEPT_STATUS_FAILURE = 'FETCH_AUTO_ACCEPT_STATUS_FAILURE';
